const url = (path) => `${process.env.PUBLIC_URL}${path}`;

export const eventTypes = [
    { slug: "all", label: "Alles" },
    { slug: "verjaardag", label: "Verjaardagen" },
    { slug: "bruiloft", label: "Bruiloften" },
    { slug: "bedrijfsfeest", label: "Bedrijfsfeesten" },
    { slug: "babyshower", label: "Babyshowers" },
    { slug: "jubileumfeest", label: "Jubileumfeesten" },
    { slug: "communie", label: "Communies" },
];

export const typeLabel = (slug) => {
    const map = {
        verjaardag: "Verjaardag",
        bruiloft: "Bruiloft",
        bedrijfsfeest: "Bedrijfsfeest",
        babyshower: "Babyshower",
        jubileumfeest: "Jubileumfeest",
        communie: "Communiefeest",
    };
    return map[slug] || slug;
};

const serviceLabel = (slug) => {
    const map = {
        cijfers: "Cijfers & Letters",
        verlichting: "Verlichting",
        ballon: "Ballondecoratie",
        photobooth: "Photobooth",
        dansvloer: "LED-Dansvloer",
    };
    return map[slug] || slug;
};

export { serviceLabel };

const events = [
    {
        slug: "bruiloft-vught-2024",
        title: "Bruiloft — Vught 2024",
        type: "bruiloft",
        services: ["ballon"],
        caption:
            "Ceremonie op een steiger aan het water, met koningsblauwe accenten, ballonpilaren bij de entree en een zilveren glitterwand.",
        photos: [
            {
                src: url("/images-v2/portfolio/bruiloft/vught-2024/1.webp"),
                alt: "Trouwceremonie op een steiger aan het water met blauwe strikken",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/vught-2024/2.webp"),
                alt: "Zilveren glitterwand met ballonslinger in blauw en zilver",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/vught-2024/3.webp"),
                alt: "Lange dinertafel met blauwe loper en ballondecoratie",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/vught-2024/4.webp"),
                alt: "Ballonpilaren in blauw en wit bij de entree",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/vught-2024/5.webp"),
                alt: "Witte stoelen met koningsblauwe organza strikken",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/vught-2024/6.webp"),
                alt: "Welkomstbord van de bruiloft met ballonslinger",
            },
        ],
        featured: true,
    },
    {
        slug: "21e-verjaardag-st-willebrord-2025",
        title: "21e Verjaardag — St. Willebrord 2025",
        type: "verjaardag",
        services: ["cijfers", "ballon", "dansvloer", "photobooth"],
        caption:
            "Een 21e verjaardag met LED-letters, een ballonplafond boven de LED-dansvloer en een fotobooth met glitterwand.",
        photos: [
            {
                src: url("/images-v2/portfolio/verjaardag/st-willebrord-2025/1.webp"),
                alt: "LED-letters en cijfers met ballondecoratie en discoballen",
            },
            {
                src: url("/images-v2/portfolio/verjaardag/st-willebrord-2025/2.webp"),
                alt: "Ballonplafond boven de LED-dansvloer",
            },
            {
                src: url("/images-v2/portfolio/verjaardag/st-willebrord-2025/3.webp"),
                alt: "Photobooth met glitterwand en chrome ballonnen",
            },
            {
                src: url("/images-v2/portfolio/verjaardag/st-willebrord-2025/4.webp"),
                alt: "Statafels met ballonnen en sfeervolle uplighting",
            },
        ],
        featured: true,
    },
    {
        slug: "bruiloft-etten-leur-2025",
        title: "Bruiloft — Etten-Leur 2025",
        type: "bruiloft",
        services: ["cijfers", "ballon", "photobooth"],
        caption:
            "Kerkbruiloft met verlichte initialen, ballonslingers in zachte tinten en een fotobooth voor de gasten.",
        photos: [
            {
                src: url("/images-v2/portfolio/bruiloft/etten-leur-2025/7.webp"),
                alt: "Welkomstbord 'Welkom op de bruiloft van Jur & Romy' met ballonslinger",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/etten-leur-2025/1.webp"),
                alt: "Verlichte LED-initialen met hart en ballonslinger",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/etten-leur-2025/2.webp"),
                alt: "Ballonslinger in groen en perzik rond de deuropening",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/etten-leur-2025/3.webp"),
                alt: "Ceremoniestoelen met groene satijnen strikken",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/etten-leur-2025/4.webp"),
                alt: "Photobooth met props voor de gasten",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/etten-leur-2025/5.webp"),
                alt: "Tafels met ballondecoratie in de feestzaal",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/etten-leur-2025/6.webp"),
                alt: "Stoeldetail met droogbloemen en groene strik",
            },
        ],
    },
    {
        slug: "bedrijfsfeest-eindhoven-2025",
        title: "Bedrijfsfeest — Eindhoven 2025",
        type: "bedrijfsfeest",
        services: ["cijfers", "ballon", "photobooth"],
        caption:
            "Zakelijke avond met grote LED-letters op het podium, ballondecoratie op de statafels en een fotobooth met gouden glitterwand.",
        photos: [
            {
                src: url("/images-v2/portfolio/bedrijfsfeesten/eindhoven-2025/1.webp"),
                alt: "Grote LED-letters op het podium",
            },
            {
                src: url("/images-v2/portfolio/bedrijfsfeesten/eindhoven-2025/2.webp"),
                alt: "Statafels met ballondecoratie in groen, zwart en goud",
            },
            {
                src: url("/images-v2/portfolio/bedrijfsfeesten/eindhoven-2025/3.webp"),
                alt: "Photobooth met gouden glitterwand",
            },
        ],
    },
    {
        slug: "babyshower-prinsenbeek-2026",
        title: "Babyshower — Prinsenbeek 2025",
        type: "babyshower",
        services: ["ballon", "verlichting"],
        caption:
            "Babyshower in roze en goud met ballondecoratie, BABY-blokken en een LED-hart als blikvanger.",
        photos: [
            {
                src: url("/images-v2/portfolio/babyshower/prinsenbeek-2026/1.webp"),
                alt: "Gedekte feesttafel in roze en goud met ballonnen",
            },
            {
                src: url("/images-v2/portfolio/babyshower/prinsenbeek-2026/2.webp"),
                alt: "Ballonslinger in roze, wit en goud op een backdrop",
            },
            {
                src: url("/images-v2/portfolio/babyshower/prinsenbeek-2026/3.webp"),
                alt: "BABY-blokken gevuld met ballonnen",
            },
            {
                src: url("/images-v2/portfolio/babyshower/prinsenbeek-2026/4.webp"),
                alt: "LED-hart met teddybeer en ballondecoratie",
            },
            {
                src: url("/images-v2/portfolio/babyshower/prinsenbeek-2026/5.webp"),
                alt: "Couvert met roze servet en goud bestek",
            },
            {
                src: url("/images-v2/portfolio/babyshower/prinsenbeek-2026/6.webp"),
                alt: "Welkomstbord van de babyshower",
            },
        ],
    },
    {
        slug: "jubileumfeest-breda-2025",
        title: "Jubileumfeest — Breda 2025",
        type: "jubileumfeest",
        services: ["dansvloer", "ballon", "photobooth"],
        caption:
            "Jubileum met LED-dansvloer, ballondecoratie door de hele zaal en een fotobooth met donkere glitterwand.",
        photos: [
            {
                src: url("/images-v2/portfolio/jubileumfeest/breda-2025/1.webp"),
                alt: "LED-dansvloer voor het podium met sfeerverlichting",
            },
            {
                src: url("/images-v2/portfolio/jubileumfeest/breda-2025/2.webp"),
                alt: "Photobooth met donkere glitterwand en ballonslinger",
            },
            {
                src: url("/images-v2/portfolio/jubileumfeest/breda-2025/3.webp"),
                alt: "Tafels met ballondecoratie in paars en lila",
            },
            {
                src: url("/images-v2/portfolio/jubileumfeest/breda-2025/4.webp"),
                alt: "Ballonpilaar in goud en oudroze",
            },
        ],
    },
    {
        slug: "bruiloft-den-hout-2024",
        title: "Bruiloft — Den Hout 2024",
        type: "bruiloft",
        services: ["ballon"],
        caption:
            "Boho-bruiloft aan het water met pampas, terracotta accenten en ballondecoratie in goud en wit.",
        photos: [
            {
                src: url("/images-v2/portfolio/bruiloft/den-hout-2024/1.webp"),
                alt: "Ceremonie onder een stretchtent aan het water",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/den-hout-2024/2.webp"),
                alt: "Groot pampas-arrangement aan de waterkant",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/den-hout-2024/3.webp"),
                alt: "Gedekte tafel met terracotta loper en droogbloemen",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/den-hout-2024/4.webp"),
                alt: "Welkomstbord met ballonslinger in goud en wit",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/den-hout-2024/5.webp"),
                alt: "Stoeldetail met chiffon en pampas",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/den-hout-2024/6.webp"),
                alt: "Feestlocatie met ballondecoratie op de tafels",
            },
            {
                src: url("/images-v2/portfolio/bruiloft/den-hout-2024/7.webp"),
                alt: "Couvert met naamkaartje en eucalyptus",
            },
        ],
    },
    {
        slug: "bedrijfsfeest-sprundel-2026",
        title: "Bedrijfsfeest — Sprundel 2026",
        type: "bedrijfsfeest",
        services: ["cijfers", "ballon"],
        caption:
            "Bedrijfsfeest met LED-letters, ballonpilaren bij de entree en een gouden glitterwand met neon.",
        photos: [
            {
                src: url("/images-v2/portfolio/bedrijfsfeesten/sprundel-2026/1.webp"),
                alt: "LED-letters verlicht in de avond",
            },
            {
                src: url("/images-v2/portfolio/bedrijfsfeesten/sprundel-2026/2.webp"),
                alt: "Gouden glitterwand met neonbord en ballonslinger in rood, zwart en goud",
            },
            {
                src: url("/images-v2/portfolio/bedrijfsfeesten/sprundel-2026/3.webp"),
                alt: "Ballonpilaren in rood, zwart en goud bij de entree",
            },
        ],
    },
    {
        slug: "eerste-communie-2026",
        title: "Eerste Communie — 2026",
        type: "communie",
        services: ["cijfers"],
        caption:
            "Grote verlichte letters voor een eerste communie — een blikvanger die meteen de toon zet.",
        photos: [
            {
                src: url("/images-v2/portfolio/communie/eerste-communie-2026/2.webp"),
                alt: "Verlichte letters Eerste Communie in een donkere zaal",
            },
            {
                src: url("/images-v2/portfolio/communie/eerste-communie-2026/1.webp"),
                alt: "Verlichte letters Eerste Communie",
            },
        ],

    },
];

export default events;
